import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";

import { GET_COUPON, GetCouponAction, getCouponEnd } from "../actions";

export function* getCoupon(action: GetCouponAction) {
    yield put(loading(true, action));

    try {
        const { couponCode, credentials, plan } = action.payload;
        const api = new ApiGatewayApi({ xappUserToken: credentials.accessToken });
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.getCoupon({ coupon: couponCode, plan });

        yield put(getCouponEnd(undefined, result.coupon));
        yield put(loading(false, action));
        yield put(addNotification(`Promo Code "${couponCode}" successfully applied to your order`));
    } catch (error) {
        yield put(getCouponEnd(error, undefined));

        if (error.message.indexOf("404") === -1) {
            yield put(addNotification(error.message, true));
        }

        yield put(loading(false, action));
    }
}

export function* watchGetCoupon() {
    yield takeEvery(GET_COUPON, getCoupon);
}
